import {isNil} from 'ramda';

import {GetEmployeeCostCentersListApiResponse} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export const getOptionsFromActiveCostCenters = (
  costCenters: GetEmployeeCostCentersListApiResponse | Nullish
) => {
  if (isNil(costCenters?.costCenters)) {
    return [];
  }

  return costCenters?.costCenters
    ?.filter((costCenter) => costCenter?.isActive)
    .map((activeConstCenter) => ({
      label: activeConstCenter?.description,
      value: activeConstCenter?.id,
    }));
};
